import {
  REACT_APP_CLIENT_NAME,
  REACT_APP_CI_COMMIT_SHA,
  REACT_APP_CI_COMMIT_TAG,
} from "config";

export const COPYRIGHT = `© ${REACT_APP_CLIENT_NAME} ${new Date().getFullYear()}. All Rights Reserved.
Version ${REACT_APP_CI_COMMIT_TAG} Build ${REACT_APP_CI_COMMIT_SHA}`;
